import { useQuery, useMutation } from 'react-query';
import queryGetContracts from './queries/getContracts';
import queryGetContractsFromProvider from './queries/getContractsFromProvider';
import mutationUpdateContractLabel from './mutations/updateContractLabel';
import mutationRemoveContract from './mutations/removeContract';
import queryGetTerminalContracts from './queries/getTerminalContracts';
import mutationAddContractByApiKey from './mutations/addContractByApiKey';
import mutationAddVadContract from './mutations/addVadContract';
import mutationAddContracts from './mutations/addContracts';
import mutationDeleteMultipleContracts from './mutations/deleteMultipleContracts';
import mutationUpdateContractLabel2 from './mutations/updateContractLabel2';

const actionsContracts = {
    // Getters
    getContracts: (params, enabled) => useQuery(queryGetContracts(params, enabled)),
    getContractsFromProvider: (query, enabled) => useQuery(queryGetContractsFromProvider(query, enabled)),
    getTerminalContracts: (params, enabled) => useQuery(queryGetTerminalContracts(params, enabled)),

    // Add external contracts
    addContractByApiKey: (onSuccess, onError) => useMutation(mutationAddContractByApiKey(onSuccess, onError)),
    addVadContract: (onSuccess, onError) => useMutation(mutationAddVadContract(onSuccess, onError)),

    // Add contracts
    addContracts: (onSuccess, onError) => useMutation(mutationAddContracts(onSuccess, onError)),

    // Mutations
    updateLabel: (onSuccess, onError) => useMutation(mutationUpdateContractLabel(onSuccess, onError)),
    updateLabel2: (onSuccess, onError) => useMutation(mutationUpdateContractLabel2(onSuccess, onError)),
    removeContract: (onSuccess, onError) => useMutation(mutationRemoveContract(onSuccess, onError)),
    // Delete multiple contracts
    deleteMultipleContracts: (onSuccess, onError) => useMutation(mutationDeleteMultipleContracts(onSuccess, onError))
};

export default actionsContracts;